var app = angular.module('leonardo');

var AccountRequestService = function(BaseRestService) {
  var service = new BaseRestService('account-requests');

  service.STATUS_PENDING = '0';
  service.STATUS_ACTIVE = '1';
  service.STATUS_REJECTED = '2';

  service.STATUS_OPTIONS = [
    {id: service.STATUS_PENDING, name: 'Pending'},
    {id: service.STATUS_ACTIVE, name: 'Active'},
    {id: service.STATUS_REJECTED, name: 'Rejected'}
  ];

  service.getStatuses = function() {
    return [
      service.STATUS_PENDING,
      service.STATUS_ACTIVE,
      service.STATUS_REJECTED
    ];
  };

  service.activate = function(account, sector, name) {
    var data = {
      sector: sector,
      name: name
    };
    return account.customPOST(data, 'accept');
  };

  service.reject = function(account) {
    return account.customPOST({}, 'reject');
  };

  return service;
};

app.factory('AccountRequestService', ['BaseRestService', AccountRequestService]);
